import { serverMergeChains } from '../data/serverMaps';

/**
 * Get all servers that are part of the same merge chain as the selected server.
 * @param selectedServer - The server selected by the user.
 * @returns A set of all related servers.
 */
export const getAllRelatedServers = (selectedServer: string): Set<string> => {
  const relatedServers = new Set<string>();

  serverMergeChains.forEach(chain => {
    if (chain.includes(selectedServer)) {
      chain.forEach(server => relatedServers.add(server));
    }
  });

  return relatedServers;
}; 